import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const VendorSelected = (props) => {
  const { parameters, groupName } = props;
  const name = 'vendor_selected';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

export default VendorSelected;
